import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import createToolbar from './toolbar';
import { GALLERY_TYPE, getDefaultComponentData } from './types';
import galleryComponentWrapper from './components/GalleryComponentWrapper/gallery-component-wrapper';
import BadPlugin from '../../components/BadPlugin';
import { createBasePlugin } from 'wix-rich-content-plugin-commons';
function galleryPluginCreator(pluginConfig) {
    return (config = {})=>{
        var _config_Gallery;
        const { decorator , helpers , t , theme , isMobile , anchorTarget , relValue , gallery  } = config, rest = _object_without_properties(config, [
            "decorator",
            "helpers",
            "t",
            "theme",
            "isMobile",
            "anchorTarget",
            "relValue",
            "gallery"
        ]);
        return createBasePlugin(_object_spread({
            component: pluginConfig.component ? galleryComponentWrapper(pluginConfig.component) : BadPlugin,
            decorator,
            settings: _object_spread_props(_object_spread({}, gallery, pluginConfig), {
                defaultLayout: (_config_Gallery = config['Gallery']) === null || _config_Gallery === void 0 ? void 0 : _config_Gallery.defaultLayout
            }),
            theme,
            type: GALLERY_TYPE,
            toolbar: createToolbar({
                helpers,
                t,
                pluginConfig
            }),
            helpers,
            isMobile,
            anchorTarget,
            relValue,
            t,
            defaultPluginData: getDefaultComponentData()
        }, rest), {});
    };
}
export { galleryPluginCreator };
